import { Element } from '../../../common/html/element'
import { INDUSTRY_TYPE } from '../constant'
import classes from './index.module.scss'
import { IndustryTable } from './IndustryTable'

export const Industry = () => {
  return (
    <Element className={classes.industry}>
      <IndustryTable type={INDUSTRY_TYPE.VSIC} />
      <Element
        className={classes.verticalLine}
        style={{ backgroundColor: '#D5D5D5' }}
      />
      <IndustryTable type={INDUSTRY_TYPE.ICB} />
    </Element>
  )
}
